import { DataDogRumLogger } from './DataDogRumLogger'

export const createDataDogRumLogger = () => {
  // Logs are only sent to DataDog if the RUM SDK is initialized
  return new DataDogRumLogger()
}
